import { render, staticRenderFns } from "./SiteChangePassword.vue?vue&type=template&id=a0f7389c&scoped=true"
import script from "./SiteChangePassword.vue?vue&type=script&lang=js"
export * from "./SiteChangePassword.vue?vue&type=script&lang=js"
import style0 from "./SiteChangePassword.vue?vue&type=style&index=0&id=a0f7389c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2_postcss@8.5.15___lodash@4.18.1_pre_97827144a0f6aa48df0612a675550f8c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f7389c",
  null
  
)

export default component.exports